import type { ModelResponse } from '../shared/types/Model'
import type { Mode } from '../shared/types/Mode'

const ROLEPLAY_IMAGE_VERSION = '20260423-r12'

const ROLEPLAY_FRAME_COUNTS: Record<number, number> = {
  1: 3,
  2: 3,
  3: 3,
  4: 3,
  5: 3,
  6: 3,
}

const ROLEPLAY_FRAME_ORDER_OVERRIDES: Partial<Record<number, readonly number[]>> = {
  5: [3, 2, 1],
}

function withRoleplayVersion(path: string) {
  return `${path}?v=${ROLEPLAY_IMAGE_VERSION}`
}

function normalizeRealismAvatarUrl(raw: string) {
  return raw.replace(/^\/src\/assets/, '')
}

function resolveRealismExtraAvatarUrl(avatar: string): string | null {
  const match = avatar.match(/(\d+)\.jpg$/)
  if (!match) return null
  const num = match[1]
  return avatar.replace(`${num}.jpg`, `${num}${num}.jpg`)
}

function getRoleplayFrameOrder(modelId: number): number[] {
  const frameCount = ROLEPLAY_FRAME_COUNTS[modelId] ?? 2
  const override = ROLEPLAY_FRAME_ORDER_OVERRIDES[modelId]

  if (override?.length) {
    return override.filter((frame) => frame >= 1 && frame <= frameCount)
  }

  return Array.from({ length: frameCount }, (_, index) => index + 1)
}

export function buildModelImageGallery(
  model: Pick<ModelResponse, 'id' | 'avatarUrl'>,
  mode: Mode = 'realism',
): string[] {
  if (mode === 'roleplay') {
    return getRoleplayFrameOrder(model.id).map((frame) =>
      withRoleplayVersion(`images/rp/${String(model.id).repeat(frame)}.jpg`),
    )
  }

  const avatar = normalizeRealismAvatarUrl(model.avatarUrl)
  const secondImage = resolveRealismExtraAvatarUrl(avatar)

  return [avatar, secondImage || `${avatar}?v=1`].filter(Boolean)
}
